import { usePermanent } from "@suse-o11y/use-permanent";
import Konva from "konva";
import React from "react";

import { Container, type ContainerConfig } from "./Container";

export type GroupConfig = ContainerConfig;

export type GroupProps = GroupConfig;

export const Group: React.FC<React.PropsWithChildren<GroupProps>> = ({ children, ...config }) => {
	const group = usePermanent(() => new Konva.Group(config));

	return (
		<Container instance={group} {...config}>
			{children}
		</Container>
	);
};
